import template from './wageAdvanceForm.html';
import controller from './wageAdvanceForm.controller';
import './wageAdvanceForm.scss';

let wageAdvanceFormComponent = {
  restrict: 'E',
  bindings: {
    onSubmit: '&',
    wageAdvanceReasonsList: '<',
    checkServiceClosed: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default wageAdvanceFormComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceForm/wageAdvanceForm.component.js